var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 13.0792C26 5.85498 20.1805 0 13 0C5.81953 0 0 5.85498 0 13.0792C0 19.6086 4.75312 25.0191 10.9688 26V16.8599H7.66797V13.0792H10.9688V10.1977C10.9688 6.92022 12.9086 5.10906 15.8793 5.10906C17.3012 5.10906 18.7891 5.36451 18.7891 5.36451V8.58322H17.1488C15.534 8.58322 15.0312 9.59226 15.0312 10.6268V13.0792H18.6367L18.0604 16.8599H15.0312V26C21.2469 25.0191 26 19.6086 26 13.0792Z",
    fill: "#121258"
  })));
}

export default SvgFb;